var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isExternal
    ? _c(
        "div",
        _vm._g(
          {
            staticClass: "svg-external-icon svg-icon",
            style: _vm.styleExternalIcon,
          },
          _vm.$listeners
        )
      )
    : _c(
        "img",
        _vm._g(
          {
            staticClass: "svg-icon",
            class: _vm.svgClass,
            attrs: {
              "aria-hidden": "true",
              src: require(`@/icons/svg/${_vm.iconClass}.svg`),
              alt: "",
            },
          },
          _vm.$listeners
        )
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }